import type {
    BUYER,
    CO_BUYER,
    ENTITY_OTHER,
    LENDER,
    TRADE_IN,
    VEHICLE_INSURANCE,
    VEHICLE_ENTITY,
    GAP,
    ACCESSORIES
} from '@makemydeal/dr-shared-types';

export enum RuleType {
    REQUIRED = 'REQUIRED',
    MAX_LENGTH = 'MAX_LENGTH',
    MIN_LENGTH = 'MIN_LENGTH',
    REGEX = 'REGEX',
    DISTINCT_VALUES = 'DISTINCT_VALUES',
    EQUALS = 'EQUALS',
    CUSTOM = 'CUSTOM' // for user-defined evaluators
}

export const EVALUATION_TYPE_COLLECTION = 'collection';
export const EVALUATION_TYPE_NESTED = 'nested';

export type ValidationRule = {
    type: RuleType | string; // allow unknown to be skipped
    message: string;
    // Optional parameters for built-in rules
    value?: number | string | boolean; // number for MAX_LENGTH/MIN_LENGTH
    pattern?: RegExp; // for REGEX
    // Optional contextual constraints
    excludeOfferTypes?: string[];
    excludeFuelTypes?: string[];
    applicableStates?: string[];
    // Optional conditional predicate: when provided, rule applies only if returns true
    when?: (input: Record<string, any>) => boolean;
    evaluator?: (value: any, input?: Record<string, any>) => boolean; // for CUSTOM rules
};

export type ValidationEntity =
    | typeof BUYER
    | typeof CO_BUYER
    | typeof ENTITY_OTHER
    | typeof LENDER
    | typeof VEHICLE_INSURANCE
    | typeof ACCESSORIES
    | typeof GAP
    | typeof VEHICLE_ENTITY
    | typeof TRADE_IN;

export type FieldErrorState = {
    objectType: ValidationEntity;
    fieldName: string;
    errors: string[];
    index?: number;
};

export type ValidationErrorState = (FieldErrorState | string)[];

export type FieldConfig = {
    evaluationType?: string;
    rules?: ValidationRule[];
    config?: ValidationConfigMap;
    errorPrefix?: string;
    fieldName?: string;
    objectType?: ValidationEntity;
};

export type ValidationConfigMap = Record<string, FieldConfig>;

export type EngineContext = {
    // Common context fields used by some domains; optional
    offerType?: string | null;
    buyerState?: string | null;
    fuelType?: string | null;
    // Allow arbitrary context extensions
    [key: string]: any;
};

export type FieldErrorConfig = {
    maxLength?: number;
    maxLengthError?: string;
    isRequired?: boolean;
    requiredErrorMessage?: string;
    regex?: RegExp;
    regexError?: string;
    custom?: (value: string) => string | null;
};

export type FieldsConfig = Record<string, FieldConfig>;
export type EntityConfig = FieldConfig | FieldsConfig;
export type ConfigMap = Record<string, EntityConfig>;
